import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
const faqs = [{
  q: 'What if my income is too low for the 50/20/30 budget?',
  a: 'The system includes adjusted splits for every income level — including 65/10/25 and 70/10/20 frameworks designed specifically for incomes under $35,000/year. Carlos started at $2,900/month and made it work. The principle matters more than the exact percentages: every dollar gets a job. The book shows you how to assign them.'
}, {
  q: "What if the negotiation call doesn't work?",
  a: "The book includes complete rebuttal scripts for every objection — the retention department strategy, the callback plan, and word-for-word responses to the six most common 'no' answers. Most people who fail the first call succeed on the second. And the Chapter 5 guarantee covers you regardless. If you don't save $9.99 from any call, you get a full refund."
}, {
  q: 'Should I save money or pay off debt first?',
  a: "Build the $1,000 Emergency Shield first — Chapter 8 explains exactly why, and it's counterintuitive. Without that buffer, one car repair or medical bill puts you right back into debt and erases all progress. The system handles both — in the right order — so you're never choosing between safety and progress."
}, {
  q: 'Is this a physical book or digital only?',
  a: 'Digital only — instant PDF download. You get the complete system immediately after purchase on any device. No shipping, no waiting, no delay before your first call. You can start reading in five minutes and make your first negotiation call tonight.'
}, {
  q: "What if my income is irregular or I'm self-employed?",
  a: "Use the average of your last 3 months as your baseline budget number. On high months, accelerate your Debt Attack. On low months, protect the Emergency Shield and hit minimums only. Chapter 3 covers variable income specifically. The system was designed to flex — not to demand predictability you don't have."
}, {
  q: 'How is this different from every other debt book?',
  a: 'Most debt books give you a philosophy. A few give you a framework. This one gives you 19 tools — worksheets you fill in, templates you use, scripts you read word-for-word on the phone, and a weekly ritual that keeps you on track in 15 minutes.\n\nThe difference between knowing what to do and actually doing it is the difference between a map and a GPS with turn-by-turn directions.\n\nThis is the GPS.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-[100px] px-5" data-id="element-157">
      <div className="max-w-[800px] mx-auto" data-id="element-158">
        <h2 className="font-serif text-[36px] md:text-[40px] text-primary-dark text-center mb-12" data-id="element-159">
          Questions You're Probably Asking
        </h2>

        <div className="flex flex-col" data-id="element-160">
          {faqs.map((faq, index) => <div key={index} className="border-b border-black/10" data-id="element-161">
              <button onClick={() => toggleFAQ(index)} className="w-full text-left py-[28px] flex justify-between items-center focus:outline-none" data-id="element-162">
                <span className="font-sans text-[18px] font-bold text-primary-dark pr-8" data-id="element-163">
                  {openIndex === index ? '−' : '+'} {faq.q}
                </span>
              </button>
              <AnimatePresence data-id="element-164">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-165">
                    <div className="pb-[28px] font-sans text-[17px] text-primary-dark/60 leading-[1.9] whitespace-pre-wrap" data-id="element-166">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>

        <div className="flex justify-center mt-12" data-id="element-167">
          <CTAButton subText="Instant PDF · All 19 tools · Chapter 5 guarantee" data-id="element-168">
            NO MORE QUESTIONS — GET THE SYSTEM → $9.99
          </CTAButton>
        </div>
      </div>
    </section>;
}